export const changeTheViewContextMenuOption = "Jnd";
export const densitySectionLabel = "Knd";
export const messageHeightSectionLabel = "Lnd";
export const multipleRowsLabel = "Mnd";
export const autoSwitchRowStyleLabel = "Nnd";
export default {changeTheViewContextMenuOption,densitySectionLabel,messageHeightSectionLabel,multipleRowsLabel,autoSwitchRowStyleLabel};